/**
 * Order
 */

const initPayer = {
    id: null,
    name: '',
    type: null,
};

const initDelivery = {
    id: null,
    name: '',
};

const initAddress = {
    id: null,
    address: '',
};

const initPickupPoint = {
    id: null,
    address: '',
    name: '',
};

const initPayment = {
    id: null,
    name: '',
};

const initRecipient = {
    id: null,
    name: '',
};

const initContact = {
    name: '',
    phone: ''
};

//TODO: если сумма заказа в корзине изменилась, обновить корзину
export const order = {
    namespaced: true,

    state: () => ({
        order: [],
        payer: { ...initPayer },
        delivery: { ...initDelivery },
        address: { ...initAddress },
        pickup_point: { ...initPickupPoint },
        recipient: { ...initRecipient },
        contact: { ...initContact },
        payment: { ...initPayment },
        comment: null,
        errors: {},
        recheckValidation: false,
        deliveryPrice: 0,
        isSaving: false,
        agree_offer: false,
    }),

    mutations: {
        resetDelivery: (state) => {
            state.delivery = { ...initDelivery };
        },

        resetAddress: (state) => {
            state.address = { ...initAddress };
        },

        resetPickupPoint: (state) => {
            state.pickup_point = { ...initPickupPoint };
        },

        resetPayment: (state) => {
            state.payment = { ...initPayment };
        },

        choosePayer(state, payload) {
            state.payer = { ...payload };
        },

        chooseDelivery(state, payload) {
            state.delivery = { ...payload };
        },

        chooseAddress: (state, payload) => {
            state.address = { ...payload };
        },

        choosePickupPoint: (state, payload) => {
            state.pickup_point = { ...payload };
        },

        chooseRecipient: (state, payload) => {
            state.recipient = { ...payload };
        },

        choosePayment: (state, payload) => {
            state.payment = { ...payload };
        },

        setErrors: (state, payload) => {
            state.errors = payload;
        },

        setIsSaving: (state, payload) => {
            state.isSaving = payload;
        },

        setRecheckValidation: (state, payload) => {
            state.recheckValidation = payload;
        },

        setComment: (state, payload) => {
            state.comment = payload;
        },

        setAgreeWithOffer: (state, payload) => {
            state.agree_offer = payload;
        }
    },

    actions: {
        choosePayer: ({ commit, dispatch, state }, payload) => {
            commit('choosePayer', payload);

            commit('resetPayment');
            commit('resetDelivery');
            commit('resetAddress');
            commit('resetPickupPoint');

            // После выборе плательщка обновляем корзину
            // У плательщика может быть персональная скидка
            dispatch('cart/getCart', { payer: payload.id }, { root: true });

            if (state.recheckValidation) {
                dispatch('validate');
            }
        },

        chooseDelivery: ({ commit, dispatch, state }, payload) => {
            commit('chooseDelivery', payload);

            commit('resetAddress');
            commit('resetPickupPoint');
            commit('resetPayment');

            if (state.recheckValidation) {
                dispatch('validate');
            }
        },

        chooseAddress: ({ commit, dispatch, state }, payload) => {
            commit('chooseAddress', payload);

            if (state.recheckValidation) {
                dispatch('validate');
            }
        },

        choosePickupPoint: ({ commit, dispatch, state }, payload) => {
            commit('choosePickupPoint', payload);

            if (state.recheckValidation) {
                dispatch('validate');
            }
        },

        chooseRecipient: ({ commit, dispatch, state }, payload) => {
            commit('chooseRecipient', payload);

            if (state.recheckValidation) {
                dispatch('validate');
            }
        },

        choosePayment: ({ commit, dispatch, state }, payload) => {
            commit('choosePayment', payload);

            if (state.recheckValidation) {
                dispatch('validate');
            }
        },

        changeRecipientName: ({ commit, dispatch, state }, payload) => {
            if (state.recheckValidation) {
                dispatch('validate');
            }
        },

        changeRecipientPhone: ({ commit, dispatch, state }, payload) => {
            if (state.recheckValidation) {
                dispatch('validate');
            }
        },

        updateComment: ({ commit, dispatch, state }, payload) => {
            commit('setComment', payload);
        },

        updateAgreeWithOffer: ({ commit, dispatch, state }, payload) => {
            commit('setAgreeWithOffer', payload);
        },

        validate: ({ commit, dispatch, state, getters }, makeOrder = false) => {
            let errors = {};

            if (!state.payer.id) {
                errors.payer = 1;
            }

            if (!state.delivery.id) {
                errors.delivery = 1;
            }

            if (!getters.pickup_points.length && state.delivery.id > 1 && !state.address.id) {
                errors.address = 1;
            }

            if (getters.pickup_points.length && !state.pickup_point.id) {
                errors.pickup_point = 1;
            }

            // if (!state.recipient.id) {
            //     errors.recipient = 1;
            // }

            // if (state.recipient.id > 1 && !state.contact.name) {
            //     errors.contactName = 1;
            // }

            // if (state.recipient.id > 1 && !state.contact.phone) {
            //     errors.contactPhone = 1;
            // }

            if (!state.payment.id) {
                errors.payment = 1;
            }

            if (state.payer.type == 3 && !state.agree_offer) {
                errors.agree_offer = 1;
            }

            commit('setErrors', errors);
            commit('setRecheckValidation', true);

            if (Object.keys(errors).length == 0 && makeOrder) {
                dispatch('order');
            }
        },

        order: ({ commit, dispatch, state }) => {
            let clientID = document.getElementById('clientID').value;

            let params = {
                payer_id: state.payer.id,
                delivery_id: state.delivery.id,
                delivery_address_id: state.address.id,
                delivery_pickup_point_id: state.pickup_point.id,
                recipient_id: state.recipient.id,
                recipient_name: state.contact.name,
                recipient_phone: state.contact.phone,
                payment_method_id: state.payment.id,
                comment: state.comment,
                client_id: clientID
            };

            commit('setIsSaving', true);

            axios.post('/ajax/order/store', params)
                .then(request => {
                    if (typeof request.data.items != 'undefined') {
                        let products = [];

                        for (let i = 0; i < request.data.items.length; i++) {
                            products.push({
                                "id": request.data.items[i]['sku'],
                                "name": request.data.items[i]['title'],
                                "price": request.data.items[i]['price'],
                                "quantity": request.data.items[i]['qty'],
                                "category": request.data.items[i]['category'],
                                // "variant": "",
                            })
                        }

                        // Metrika
                        ym(191405, 'reachGoal', 'order_done');

                        window.dataLayer = window.dataLayer || [];

                        window.dataLayer.push({
                            "ecommerce": {
                                "currencyCode": "RUB",
                                "purchase": {
                                    "actionField": {
                                        "id": request.data.id
                                    },
                                    "products": products
                                }
                            }
                        });

                        ym(191405, 'userParams', {
                            ...request.data.utm,
                            UserID: request.data.user_id,
                            amount: request.data.amount
                        });
                    }

                    if (typeof request.data.url != 'undefined') {
                        location.href = request.data.url;
                    }

                    commit('setSaving', false);
                    dispatch('getPayers');
                });
        }
    },

    getters: {
        errors: state => {
            return state.errors;
        },
        // Сумма товаров в корзине
        amount: (state, getters, rootState, rootGetters) => {
            let result = rootGetters['cart/amount'];

            return result;
        },
        // Старая сумма товаров в корзине
        oldAmount: (state, getters, rootState, rootGetters) => {
            let result = rootGetters['cart/oldAmount'];

            return result;
        },
        // Скидка
        discount: (state, getters, rootState, rootGetters) => {
            let result = rootGetters['cart/discount'];

            return result;
        },
        deliveryPrice: (state, getters) => {
            return state.deliveryPrice;
        },
        total: (state, getters, rootGetters) => {
            let result = rootGetters.cart.amount + state.deliveryPrice;

            return result;
        },
        pickup_points: (state, getters, rootGetters) => {
            if (state.delivery.id) {
                let delivery = rootGetters.delivery.deliveries.find(
                    (value, index) => {
                        return value.id == state.delivery.id;
                    }
                );

                if (typeof delivery.points !== "undefined") {
                    return delivery.points;
                }
            }

            return [];
        },
    }
}
